module.exports = __webpack_public_path__ + "img/_7.b3f43e7c.png";